import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { modelInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center">
          <span className="font-poppins text-xs tracking-[0.4em] text-gray-400 mb-4 block">
            GET IN TOUCH
          </span>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wider mb-8">
            Contact
          </h2>
          
          <p className="font-poppins text-gray-600 leading-relaxed mb-12 max-w-xl mx-auto">
            For bookings, collaborations, or general inquiries, please reach out through the contact information below.
          </p>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-200">
                <Mail size={20} className="text-gray-600" />
              </div>
              <div className="text-left">
                <span className="font-poppins text-xs tracking-wider text-gray-400 block mb-1">
                  EMAIL
                </span>
                <a 
                  href={`mailto:${modelInfo.email}`}
                  className="font-poppins text-sm hover:text-gray-600 transition-colors"
                >
                  {modelInfo.email}
                </a>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-200">
                <MapPin size={20} className="text-gray-600" />
              </div>
              <div className="text-left">
                <span className="font-poppins text-xs tracking-wider text-gray-400 block mb-1">
                  LOCATION
                </span>
                <span className="font-poppins text-sm">
                  {modelInfo.location}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-200">
                <Phone size={20} className="text-gray-600" />
              </div>
              <div className="text-left">
                <span className="font-poppins text-xs tracking-wider text-gray-400 block mb-1">
                  AGENCY
                </span>
                <span className="font-poppins text-sm">
                  {modelInfo.agency}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
